###
Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
For licensing, see LICENSE.md or http://ckeditor.com/license
###

CKEDITOR.lang['ja'] =
  "about":
    "copy": "Copyright © $1。全著作権所有。",
    "dlgTitle": "CKEditorについて",
    "help": "ヘルプが必要な場合は $1 を確認してください。",
    "moreInfo": "ライセンス情報については、当社のWebサイトをご覧ください。",
    "title": "CKEditorについて",
    "userGuide": "CKEditorユーザーガイド"
  "basicstyles":
    "bold": "大胆な",
    "italic": "イタリック",
    "strike": "取り消し線",
    "subscript": "添字",
    "superscript": "上付き文字",
    "underline": "下線を引く"
  "blockquote":
    "toolbar": "ブロック見積もり"
  "button":
    "selectedLabel": "%1（選択済み）"
  "clipboard":
    "copy": "コピー",
    "copyError": "ブラウザのセキュリティ設定では、エディタがコピー操作を自動的に実行することは許可されていません。そのためにキーボードを使用してください（Ctrl / Cmd + C）。",
    "cut": "切る",
    "cutError": "ブラウザのセキュリティ設定では、エディタが自動的にカット操作を実行することは許可されていません。そのためにキーボードを使用してください（Ctrl / Cmd + X）。",
    "paste": "ペースト",
    "pasteArea": "貼り付け領域",
    "pasteMsg": "キーボード（<strong>Ctrl / Cmd + V</strong>）を使用して次のボックス内に貼り付け、[OK]をクリックしてください",
    "securityMsg": "ブラウザのセキュリティ設定により、エディタはクリップボードのデータに直接アクセスできません。このウィンドウにもう一度貼り付ける必要があります。",
    "title": "ペースト"
  "common":
    "advancedTab": "高度",
    "advisoryTitle": "アドバイザリータイトル",
    "align": "配置",
    "alignBottom": "下",
    "alignCenter": "センター",
    "alignJustify": "正当化する",
    "alignLeft": "左",
    "alignMiddle": "中間",
    "alignNone": "なし",
    "alignRight": "正しい",
    "alignTop": "上",
    "browseServer": "サーバーの参照",
    "button": "ボタン",
    "cancel": "キャンセル",
    "checkbox": "チェックボックス",
    "close": "閉じる",
    "confirmCancel": "いくつかのオプションを変更しました。ダイアログウィンドウを閉じてもよろしいですか？",
    "confirmNewPage": "このコンテンツへの保存されていない変更はすべて失われます。新しいページをロードしてもよろしいですか？",
    "cssClass": "スタイルシートクラス",
    "cssClasses": "スタイルシートクラス",
    "cssLengthTooltip": "値の数値をピクセル単位で入力するか、有効なCSS単位（px、%、in、cm、mm、em、ex、pt、またはpc）を使用して数値を入力します。",
    "cssStyle": "スタイル",
    "editorHelp": "ヘルプが必要な場合はAlt0を押してください",
    "flash": "閃光",
    "form": "形",
    "generalTab": "一般",
    "height": "高さ",
    "hiddenField": "隠しフィールド",
    "id": "Id",
    "image": "画像",
    "imageButton": "画像ボタン",
    "invalidCssLength": "「%1」フィールドに指定する値は、有効なCSS測定単位（px、%、in、cm、mm、em、ex、pt、またはpc）がある場合とない場合の正の数である必要があります。",
    "invalidHeight": "高さは数値でなければなりません。",
    "invalidHtmlLength": "「%1」フィールドに指定する値は、有効なHTML測定単位（pxまたは%）の有無にかかわらず正の数である必要があります。",
    "invalidInlineStyle": "インラインスタイルに指定する値は、セミコロンで区切られた「name：value」の形式の1つ以上のタプルで構成されている必要があります。",
    "invalidValue": "値が無効です。",
    "invalidWidth": "幅は数値でなければなりません。",
    "langCode": "言語コード",
    "langDir": "言語の方向性",
    "langDirLTR": "左から右（LTR）",
    "langDirLtr": "左から右（LTR）",
    "langDirRTL": "右から左（RTL）",
    "langDirRtl": "右から左（RTL）",
    "longDescr": "長い説明のURL",
    "name": "名前",
    "notSet": "<示されていない>",
    "ok": "OK",
    "options": "オプション",
    "preview": "プレビュー",
    "protocol": "プロトコル",
    "radio": "ラジオボタン",
    "resize": "サイズ変更",
    "select": "選択フィールド",
    "styles": "スタイル",
    "target": "目標",
    "targetNew": "新しいウィンドウ（_blank）",
    "targetParent": "親ウィンドウ（_parent）",
    "targetSelf": "同じウィンドウ（_self）",
    "targetTop": "最上部のウィンドウ（_top）",
    "textField": "テキストフィールド",
    "textarea": "Textarea",
    "unavailable": "%1 <span class=\"cke_accessibility\">、利用できません</span>",
    "upload": "アップロード",
    "uploadSubmit": "サーバーに送信します",
    "url": "URL",
    "validateNumberFailed": "この値は数値ではありません。",
    "width": "幅"
  "contextmenu":
    "options": "コンテキストメニューオプション"
  "editor": "リッチテキストエディタ",
  "editorPanel": "リッチテキストエディタパネル",
  "elementspath":
    "eleLabel": "要素パス",
    "eleTitle": "%1要素"
  "fakeobjects":
    "anchor": "アンカー",
    "flash": "フラッシュアニメーション",
    "hiddenfield": "隠しフィールド",
    "iframe": "IFrame",
    "unknown": "不明なオブジェクト"
  "format":
    "label": "フォーマット",
    "panelTitle": "段落形式",
    "tag_address": "住所",
    "tag_div": "通常（DIV）",
    "tag_h1": "見出し1",
    "tag_h2": "見出し2",
    "tag_h3": "見出し3",
    "tag_h4": "見出し4",
    "tag_h5": "見出し5",
    "tag_h6": "見出し6",
    "tag_p": "正常",
    "tag_pre": "フォーマット済み"
  "horizontalrule":
    "toolbar": "水平線を挿入"
  "image":
    "alertUrl": "画像のURLを入力してください",
    "alt": "代替テキスト",
    "border": "境界",
    "btnUpload": "サーバーに送信します",
    "button2Img": "選択した画像ボタンを単純な画像に変換しますか？",
    "hSpace": "HSpace",
    "img2Button": "選択した画像を画像ボタンで変換しますか？",
    "infoTab": "画像情報",
    "linkTab": "リンク",
    "lockRatio": "ロック比",
    "menu": "画像のプロパティ",
    "resetSize": "サイズをリセット",
    "title": "画像のプロパティ",
    "titleButton": "画像ボタンのプロパティ",
    "upload": "アップロード",
    "urlMissing": "画像のソースURLがありません。",
    "vSpace": "VSpace",
    "validateBorder": "境界線は整数でなければなりません。",
    "validateHSpace": "HSpaceは整数でなければなりません。",
    "validateVSpace": "VSpaceは整数でなければなりません。"
  "indent":
    "indent": "インデントを増やします",
    "outdent": "インデントを減らす"
  "link":
    "acccessKey": "アクセスキー",
    "advanced": "高度",
    "advisoryContentType": "アドバイザリコンテンツタイプ",
    "advisoryTitle": "アドバイザリータイトル",
    "anchor":
      "errorName": "アンカー名を入力してください",
      "menu": "アンカーを編集する",
      "name": "アンカー名",
      "remove": "アンカーを削除します",
      "title": "アンカープロパティ",
      "toolbar": "アンカー"
    "anchorId": "要素ID別",
    "anchorName": "アンカー名別",
    "charset": "リンクされたリソース文字セット",
    "cssClasses": "スタイルシートクラス",
    "emailAddress": "電子メールアドレス",
    "emailBody": "メッセージ本文",
    "emailSubject": "メッセージの件名",
    "id": "Id",
    "info": "リンク情報",
    "langCode": "言語コード",
    "langDir": "言語の方向性",
    "langDirLTR": "左から右（LTR）",
    "langDirRTL": "右から左（RTL）",
    "menu": "リンクを編集",
    "name": "名前",
    "noAnchors": "（ドキュメントで使用可能なアンカーはありません）",
    "noEmail": "メールアドレスを入力してください",
    "noUrl": "リンクURLを入力してください",
    "other": "<その他>",
    "popupDependent": "依存（Netscape）",
    "popupFeatures": "ポップアップウィンドウの機能",
    "popupFullScreen": "フルスクリーン（IE）",
    "popupLeft": "左位置",
    "popupLocationBar": "ロケーションバー",
    "popupMenuBar": "メニューバー",
    "popupResizable": "サイズ変更可能",
    "popupScrollBars": "スクロールバー",
    "popupStatusBar": "ステータスバー",
    "popupToolbar": "ツールバー",
    "popupTop": "トップポジション",
    "rel": "関係",
    "selectAnchor": "アンカーを選択します",
    "styles": "スタイル",
    "tabIndex": "タブインデックス",
    "target": "目標",
    "targetFrame": "<frame>",
    "targetFrameName": "ターゲットフレーム名",
    "targetPopup": "<ポップアップウィンドウ>",
    "targetPopupName": "ポップアップウィンドウ名",
    "title": "リンク",
    "toAnchor": "テキスト内のアンカーへのリンク",
    "toEmail": "Eメール",
    "toUrl": "URL",
    "toolbar": "リンク",
    "type": "リンクタイプ",
    "unlink": "リンク解除",
    "upload": "アップロード"
  "list":
    "bulletedlist": "箇条書きの挿入/削除",
    "numberedlist": "番号付きリストの挿入/削除"
  "magicline":
    "title": "ここに段落を挿入"
  "maximize":
    "maximize": "最大化",
    "minimize": "最小化"
  "pastefromword":
    "confirmCleanup": "貼り付けたいテキストはWordからコピーされたようです。貼り付ける前に掃除しますか？",
    "error": "内部エラーのため、貼り付けたデータをクリーンアップできませんでした",
    "title": "Wordから貼り付け",
    "toolbar": "Wordから貼り付け"
  "pastetext":
    "button": "プレーンテキストとして貼り付けます",
    "title": "プレーンテキストとして貼り付け"
  "removeformat":
    "toolbar": "フォーマットを削除"
  "scayt":
    "btn_about": "SCAYTについて",
    "btn_dictionaries": "辞書",
    "btn_disable": "SCAYTを無効にする",
    "btn_enable": "SCAYTを有効にする",
    "btn_langs": "言語",
    "btn_options": "オプション",
    "text_title": "入力時のスペルチェック"
  "sourcearea":
    "toolbar": "ソース"
  "specialchar":
    "options": "特殊文字オプション",
    "title": "特殊文字を選択",
    "toolbar": "特殊文字を挿入"
  "stylescombo":
    "label": "スタイル",
    "panelTitle": "書式設定スタイル",
    "panelTitle1": "ブロックスタイル",
    "panelTitle2": "インラインスタイル",
    "panelTitle3": "オブジェクトスタイル"
  "table":
    "border": "ボーダーサイズ",
    "caption": "キャプション",
    "cell":
      "alignBaseline": "ベースライン",
      "bgColor": "背景色",
      "borderColor": "ボーダの色",
      "cellType": "セルタイプ",
      "chooseColor": "選択",
      "colSpan": "列スパン",
      "data": "データ",
      "deleteCell": "セルを削除する",
      "hAlign": "水平方向の配置",
      "header": "ヘッダ",
      "insertAfter": "後にセルを挿入",
      "insertBefore": "前にセルを挿入",
      "invalidColSpan": "列のスパンは整数でなければなりません。",
      "invalidHeight": "セルの高さは数値でなければなりません。",
      "invalidRowSpan": "行スパンは整数でなければなりません。",
      "invalidWidth": "セル幅は数値でなければなりません。",
      "menu": "細胞",
      "merge": "セルを結合します",
      "mergeDown": "マージダウン",
      "mergeRight": "マージ権",
      "no": "番号",
      "rowSpan": "行スパン",
      "splitHorizontal": "セルを水平方向に分割",
      "splitVertical": "セルを垂直に分割",
      "title": "セルのプロパティ",
      "vAlign": "垂直方向の配置",
      "wordWrap": "ワードラップ",
      "yes": "はい"
    "cellPad": "セルパディング",
    "cellSpace": "セル間隔",
    "column":
      "deleteColumn": "列を削除する",
      "insertAfter": "後に列を挿入",
      "insertBefore": "前に列を挿入",
      "menu": "カラム"
    "columns": "列",
    "deleteTable": "テーブルを削除する",
    "headers": "ヘッダー",
    "headersBoth": "両方とも",
    "headersColumn": "最初の列",
    "headersNone": "なし",
    "headersRow": "最初の行",
    "invalidBorder": "境界線のサイズは数値である必要があります。",
    "invalidCellPadding": "セルのパディングは正の数である必要があります。",
    "invalidCellSpacing": "セル間隔は正の数でなければなりません。",
    "invalidCols": "列の数は0より大きい数でなければなりません。",
    "invalidHeight": "テーブルの高さは数値でなければなりません。",
    "invalidRows": "行数は0より大きい数でなければなりません。",
    "invalidWidth": "テーブル幅は数値でなければなりません。",
    "menu": "テーブルのプロパティ",
    "row":
      "deleteRow": "行を削除する",
      "insertAfter": "後に行を挿入",
      "insertBefore": "前に行を挿入",
      "menu": "行"
    "rows": "行",
    "summary": "概要",
    "title": "テーブルのプロパティ",
    "toolbar": "テーブル",
    "widthPc": "パーセント",
    "widthPx": "ピクセル",
    "widthUnit": "幅の単位"
  "toolbar":
    "toolbarCollapse": "ツールバーを折りたたむ",
    "toolbarExpand": "ツールバーを展開",
    "toolbarGroups":
      "basicstyles": "基本的なスタイル",
      "clipboard": "クリップボード/元に戻す",
      "colors": "色",
      "document": "資料",
      "editing": "編集",
      "forms": "フォーム",
      "insert": "インサート",
      "links": "リンク",
      "paragraph": "段落",
      "styles": "スタイル",
      "tools": "ツール"
    "toolbars": "エディターツールバー"
  "undo":
    "redo": "やり直し",
    "undo": "元に戻す"
  "wsc":
    "btnIgnore": "無視する",
    "btnIgnoreAll": "全無視",
    "btnReplace": "交換",
    "btnReplaceAll": "すべて置換",
    "btnUndo": "元に戻す",
    "changeTo": "への変更",
    "errorLoading": "アプリケーションサービスホストの読み込み中にエラーが発生しました：%s。",
    "ieSpellDownload": "スペルチェッカーがインストールされていません。今すぐダウンロードしますか？",
    "manyChanges": "スペルチェックが完了しました：%1語が変更されました",
    "noChanges": "スペルチェックが完了しました：単語は変更されていません",
    "noMispell": "スペルチェックが完了しました：スペルミスは見つかりませんでした",
    "noSuggestions": "-提案なし-",
    "notAvailable": "申し訳ありませんが、サービスは現在ご利用いただけません。",
    "notInDic": "辞書にない",
    "oneChange": "スペルチェックが完了しました：1つの単語が変更されました",
    "progress": "スペルチェックが進行中です...",
    "title": "スペルチェッカー",
    "toolbar": "スペルチェックする"



// WEBPACK FOOTER //
// ./src/app/editor/widget_initializers/wysiwyg/ckeditor/lang/ja.coffee